import { Component, h, Host, Prop, State, Watch } from "@stencil/core";
import { setCurrencySymbol } from "../../utils/setCurrencySymbol";

@Component({
    tag: "ux-number-format",
    shadow: false
})
export class NumberFormat {
    /**
     * The value to format; must be formatted as a JS number (e.g., 1000 or 14.00)
     */
    @Prop() readonly value: number;

    /**
     * Locale can be set optionally; the browser locale is used as default (e.g., 'de-DE')
     */
    @Prop() readonly locale: string = "";

    /**
     * Set when you want to display the number with currency
     */
    @Prop() readonly currency?: boolean = false;

    /**
     * Holds the final result
     */
    @State() formattedNumber = "";

    /**
     * Currency short form depending on locale
     */
    @State() currencyStr = "";

    @Watch("locale")
    private useSetCurrencySymbol() {
        this.currencyStr = setCurrencySymbol(this.locale);
    }

    @Watch("value")
    @Watch("currency")
    @Watch("locale")
    private formatNumber() {
        const { value, locale, currency } = this;
        if (currency) {
            this.formattedNumber = new Intl.NumberFormat(locale, {
                style: "currency",
                currency: `${this.currencyStr}`
            }).format(value);
        } else if (locale === "" && !currency) {
            this.formattedNumber = new Intl.NumberFormat().format(value);
        } else {
            this.formattedNumber = new Intl.NumberFormat(locale).format(value);
        }
    }

    componentWillLoad() {
        this.useSetCurrencySymbol();
        this.formatNumber();
    }

    render() {
        return <Host class="ux-number-format">{this.formattedNumber}</Host>;
    }
}
